import React, { useState } from "react";
import { connect } from "react-redux";

import { Button, Input } from "@revvsales/components";

// Action Imports
import { addDocMetaData } from "../../../actions/MetalensActions/metalensActions";
// Utils
import { amplitudeLogEvent } from "../../../utils/amplitudeUtils";

// constants
import { EVENT_NAMES } from "../../../constants/events";

const AddMetalensTag = ({
  handleClose,
  addDocMetaDataAction,
  docID,
  sharingHash,
}) => {
  const [metaName, setMetaName] = useState("");
  const [metaValue, setMetaValue] = useState("");

  const _handleMetatagSubmit = () => {
    if (!metaName || !metaValue || !docID) {
      return;
    }
    const data = {
      meta_key: metaName,
      text: metaValue,
    };
    // make action call
    addDocMetaDataAction(docID, data, sharingHash)
      .then(() => {
        handleClose();
      })
      .catch(err => {
        console.error(err);
      });
    // Amplitude
    amplitudeLogEvent(EVENT_NAMES.METALENS_ADD_TAG, {
      Key: data.meta_key,
      Value: data.text,
    });
  };

  const _isDisabled = () => {
    if (!metaName || !metaValue || !docID) {
      return true;
    }
    return false;
  };

  return (
    <div className="metalens-add-tag-wrapper">
      {/* Input */}
      <div className="metalens-tag-inputs-wrapper">
        <Input
          data-test="metalens-input-title"
          onChange={e => setMetaName(e.target.value)}
          value={metaName}
          placeholder="Metatag Name"
          id="metatag-name"
          className="metalens-tag-input"
        />
        <Input
          data-test="metalens-input-tag"
          onChange={e => setMetaValue(e.target.value)}
          value={metaValue}
          placeholder="Value"
          id="metatag-value"
          className="metalens-tag-input"
        />
      </div>
      {/* Actions */}
      <div className="metalens-add-action">
        <Button
          data-test="metalens-btn-cancel-submit"
          data-belongsto="metalens-dropdown"
          className="metalens-btn-cancel"
          onClick={handleClose}
          id="metalens-action-cancel">
          &nbsp; Cancel
        </Button>
        <Button
          data-test="metalens-btn-add-submit"
          className={`${
            _isDisabled() ? "metalens-btn-add" : ""
          } metalens-btn-add-def`}
          onClick={_handleMetatagSubmit}
          id="metalens-action-add">
          &nbsp; Add
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  DocumentStore: { document: { id: docID } = {} } = {},
}) => ({
  docID,
});

const mapDispatchToProps = {
  addDocMetaDataAction: addDocMetaData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddMetalensTag);



// WEBPACK FOOTER //
// ./src/components/QuickReview/MetadataSection/AddMetalensTag.js